<div class="container-fluid cont-new">
    <div class="row ps-0 pe-3">
        <div class="col-12 ps-0">
            <div
                class="d-flex flex-row align-items-start w-100 pt-2 justify-content-between"
            >
                <div class="font-sm weight-medium">
                    @if (!audioOpen()) {
                        Outbound CLI:
                        <span class="ps-2 font-sm weight-medium">
                            {{ opCLI() }}
                        </span>
                    } @else {
                        Audio Devices
                    }
                </div>
                <div>
                    <button
                        class="audio-btn"
                        [class.active]="audioOpen()"
                        (click)="showAudio()"
                    >
                        <i class="fa-light fa-lg fa-square-sliders"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row pe-3">
        <div class="col-12 ps-0 pt-2 position-relative">
            <div
                class="voice-audio-wrapper mt-1 pe-3"
                [class.open]="audioOpen()"
            >
                <voice-audio (saved)="audioOpen.set(false)" />
            </div>
            <div
                class="input-group p-1"
                [ngClass]="{
                    'can-call': canCall(),
                    'call-failed': callState() === 'Call failed',
                    'call-engaged': callState() === 'Number busy',
                }"
            >
                @if (showDialpadButton()) {
                    <span class="input-group-text">
                        <button
                            type="button"
                            class="btn btn-dialpad p-1 text-start d-flex align-items-center justify-content-center"
                            (click)="showDialpad()"
                            [class.selected]="dialpad()"
                        >
                            <i class="fa-2x fa-light fa-grid-round"></i>
                        </button>
                    </span>
                }
                @if (displayFailed()) {
                    <span class="input-group-text">
                        <i
                            class="fa-light fa-ban fa-2x"
                            [ngClass]="
                                callState() === 'Call failed'
                                    ? 'icon-failed'
                                    : 'icon-engaged'
                            "
                        ></i>
                    </span>
                }

                <input
                    type="text"
                    class="form-control form-control-new weight-medium font-xl p-2 input-group-input"
                    placeholder="Type number"
                    aria-label="Type number"
                    (input)="onNumberChange($event)"
                    [value]="callDisplay()"
                    maxlength="15"
                    [class.disabled-input]="startedCall()"
                />
                <span
                    class="input-group-text"
                    [ngbTooltip]="callToolTip()"
                    #tooltip="ngbTooltip"
                >
                    <button
                        type="button"
                        class="btn rounded-circle p-2"
                        [ngClass]="callButtonClass()"
                        [class.btn-reject-disabled]="connecting()"
                        (click)="
                            startedCall() ? endCall(tooltip) : makeCall(tooltip)
                        "
                    >
                        <i class="fa-lg fa-solid fa-phone"></i>
                    </button>
                </span>
            </div>
        </div>
    </div>
    <div class="row pe-3">
        <div class="col-12 ps-0 pt-2">
            <div
                class="d-flex flex-row justify-content-between align-items-center"
            >
                <div>
                    <telxl-dropdown
                        colour="dropdown"
                        class="mw-20"
                        placeholder="Select Channel"
                        [outline]="true"
                        [menuItems]="costCentresData()"
                        [selected]="costCentreId()"
                        [disabled]="disabledCostCentreForInternal()"
                        maxHeight="200px"
                        (selectedChange)="onCostCentreChange($event)"
                    />
                </div>
                <div class="form-check form-switch no-switch-bg">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        [checked]="overrideWithheld()"
                        [disabled]="overrideWithheld()"
                        #withholdCheckbox
                        (change)="withholdClick(withholdCheckbox.checked)"
                    />
                    <label class="form-check-label" for="switchCheckDefault">
                        Withhold CLI
                    </label>
                </div>
            </div>
        </div>
    </div>
    @if (dialpad()) {
        <div class="row pt-4 flex-grow-1 overflow-auto pe-3">
            <div class="col-12">
                <div class="pt-4">
                    <telxl-dialpad
                        (buttonClick)="dialpadClick($event)"
                    ></telxl-dialpad>
                </div>
            </div>
        </div>
    } @else {
        <div class="row ps-0 pt-4 flex-grow-1 overflow-auto">
            <div class="col-12 ps-0 d-flex flex-column h-100">
                <div class="text-secondary font-xs pb-2">Recent Calls</div>
                @if (recentCalls()) {
                    <div class="flex-grow-1 overflow-auto">
                        @for (
                            call of recentCalls()?.historicalWorkitems;
                            track call.id;
                            let i = $index
                        ) {
                            <div class="pe-2">
                                <voice-recent-call
                                    [isActiveInput]="isSelected('rc' + i)"
                                    [call]="call"
                                    (callSelected)="
                                        callSelected($event, 'rc' + i)
                                    "
                                ></voice-recent-call>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
